/**
 * 화면 키보드가 올라와 있는지(DEV-13 0 · N-030). 앱은 키보드가 올라오면 창이 줄어듭니다(adjustResize).
 *
 * 같은 너비에서 본 가장 큰 높이보다 150px 넘게 줄면 키보드로 봅니다(회전하면 너비가 바뀌어 다시 셈).
 * 데스크톱 브라우저는 창을 줄이지 않는 한 늘 false 입니다.
 */
import { useEffect, useState } from 'react';

export const KEYBOARD_MIN_PX = 150;

export function keyboardOpenOf({ width, height }, tallest) {
    const best = tallest.get(width) ?? 0;
    if (height > best) {
        tallest.set(width, height);
        return false;
    }
    return best - height > KEYBOARD_MIN_PX;
}

export function useKeyboardOpen(win = typeof window === 'undefined' ? null : window) {
    const [open, setOpen] = useState(false);
    useEffect(() => {
        if (!win) {
            return undefined;
        }
        const tallest = new Map();
        const update = () => setOpen(keyboardOpenOf({ width: win.innerWidth, height: win.innerHeight }, tallest));
        update();
        win.addEventListener('resize', update);
        return () => win.removeEventListener('resize', update);
    }, [win]);
    return open;
}
